// extracted by mini-css-extract-plugin
export default {"WhatsSupportDialog":"+itAD6tHqvNuuA8zINZhqg==","whatsButton":"CH1xuyX4IZvvGl9IBkJRfQ==","phoneText":"-ah8+RQa08W+Au5kwZnifw=="};